export class InitializeFeatureFlags {

  static readonly type = '[FEATURE_FLAGS] initialize';

}
